<template>
    <el-dialog v-model="dialogVisible" title="批量编辑选项" width="585px" center>
        <div class="option-list">
            <div class="option-list-box" v-for="(item, index) in newOptionsList" :key="index">
                <div
                    class="option-list_item"
                    contenteditable
                    @blur="valueChange(index)"
                    :ref="(el) => (nodeList[index] = el)"
                    v-html="item.label"
                ></div>
                <div class="option-list_item_delete" @click="deleteOption(index)">-</div>
            </div>
            <el-input
                class="option-list_textarea"
                style="height: auto"
                v-model="newOption"
                :rows="8"
                type="textarea"
                placeholder="在这里新增选项，每行代表一个选项，可以添加多个选项"
            />
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmButton"> 确定 </el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { ref, watch } from "vue";
const props = defineProps(["optionsList"]);
const emits = defineEmits(["confirmOption"]);
let newOption = ref("");
let dialogVisible = ref(false);
let newOptionsList = ref([]);
let nodeList = ref([]);
defineExpose({ dialogVisible, newOption });

watch(dialogVisible, (curr, old) => {
    initData();
});
const valueChange = (index) => {
    newOptionsList.value[index].label = nodeList.value[index].innerHTML;
};
const confirmButton = () => {
    let options = newOption.value.split(/[(\r\n)\r\n]+/);
    let optionsList = ref([]);
    options.map((item) => {
        let obj = {
            label: item,
            value: newOptionsList.value.length + 1,
        };
        if (item) {
            optionsList.value.push(obj);
        }
    });

    emits("confirmOption", [...newOptionsList.value, ...optionsList.value]);
    dialogVisible.value = false;
};
// 删除
const deleteOption = (index) => {
    newOptionsList.value.splice(index, 1);
};
// 重置数据
function initData() {
    newOptionsList.value = JSON.parse(JSON.stringify(props.optionsList));
    newOption.value = "";
}
</script>
<style lang="scss" scoped>
.option-list {
    width: 100%;

    .option-list-box {
        position: relative;
        .option-list_item {
            width: 517px;
            height: 30px;
            line-height: 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(229, 232, 238, 1);
            margin-bottom: 10px;
            padding: 0 10px;
            box-sizing: border-box;
            color: rgba(112, 120, 134, 1);
            font-size: 14px;
            font-weight: 400;
            outline: none;
            &:focus {
                border-color: var(--el-color-primary);
            }
        }
        .option-list_item_delete {
            position: absolute;
            right: -10px;
            top: 50%;
            transform: translateY(-50%);
            width: 18px;
            height: 18px;
            line-height: 8px;
            border-radius: 50%;
            border: 1px solid rgba(211, 214, 222, 1);
            color: rgba(211, 214, 222, 1);
            text-align: center;
            font-size: 30px;
            cursor: pointer;
        }
    }

    .option-list_textarea {
        width: 517px;
    }
}
</style>
